'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var apiOk = function (code) {
    var __bl = window.__bl;
    //
    if (!__bl || !__bl.api) {
        console.warn("注意：前端监控还没有覆盖此页面");
        return;
    }
    __bl.api(code, true, 0);
};
var apiFail = function (code, data) {
    var __bl = window.__bl;
    if (!__bl || !__bl.api) {
        console.warn("注意：前端监控还没有覆盖此页面");
        return;
    }
    __bl.api(code, false, 0, "customerMonitor", JSON.stringify(data));
};
var sum = function (key, num) {
    var __bl = window.__bl;
    if (!__bl || !__bl.sum) {
        console.warn("注意：前端监控还没有覆盖此页面");
        return;
    }
    __bl.sum(key, num ? num : 1);
};
var api = function () {
    var __bl = window.__bl;
    if (!__bl || !__bl.api) {
        console.warn("注意：前端监控还没有覆盖此页面");
        return;
    }
    __bl.api.apply(__bl, arguments);
};
var avg = function (key, time) {
    var __bl = window.__bl;
    if (!__bl || !__bl.avg) {
        console.warn("注意：前端监控还没有覆盖此页面");
        return;
    }
    __bl.avg(key, time);
};
var error = function (errorMsg, errorInfo) {
    var __bl = window.__bl;
    if (!__bl || !__bl.error) {
        console.warn("注意：前端监控还没有覆盖此页面");
        return;
    }
    window.__bl && window.__bl.error && window.__bl.error(new Error(errorMsg), errorInfo);
};
var setArmsConfig = function (channel) {
    //从tag里添加referer涞源
    if (window.__bl && window.__bl.setConfig) {
        window.__bl.setConfig({
            tag: channel
        });
    }
};
var govMointor = {
    apiOk: apiOk,
    apiFail: apiFail,
    error: error,
    sum: sum,
    avg: avg,
    setArmsConfig: setArmsConfig,
    api: api
};
exports.default = govMointor;
